import firebase, { database } from '../firebase'
import * as constants from '../Constatnts'
import axios from 'axios';


export function getTables(storeID){
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/tables/${storeID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.tables;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function getOpenTableOrders(storeId) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
          const response = await axios.get(
        `${constants.API_URL}/opentableorders`,
        {
          params: {
            storeId,
            from: 0,
            size: 1000,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("response.data",response.data);
      return response.data.sales;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function  deleteTable(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.delete(
        `${constants.API_URL}/table/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.data.code=="0"){
        return true
      }
      else{
        return false
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function saveTable(table, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key !== "") {
        // Update existing account
        response = await axios.put(
          `${constants.API_URL}/table/${key}`,
          table,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new account
        response = await axios.post(
          `${constants.API_URL}/table`,
          table,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data.code === "0") {
        if (key) {
          return key;
        } else {
            alert(response.data.message || "failed to delete table");
          return true;
        }
      }

      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

